export const form = {
    status: 1,
}